import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'

// Internal components
import Button from '../Button/Button'
import DetailBlock from '../DetailBlock/DetailBlock'
import LazyImage from '../LazyImage/LazyImage'
import MaterialBlock from '../MaterialBlock/MaterialBlock'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const PageSummary = (props) => {
  const { entry, type, materialData, reviews } = props

  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  let detailContent = ''
  let intro = ''

  if (entry.objectiveCategories) {
    const objective = entry.objectiveCategories
      ? entry.objectiveCategories.filter((objective) => {
          return objective.level === 2
        })
      : false
    detailContent = objective?.length ? `<h3>${t('PAGESUMMARY__OBJECTIVE')}</h3><p>${objective[0]?.title}</p>` : ''
  }

  if (type === 'training') {
    const trainingIntroRaw =
      typeof entry?.trainingIntro === 'string' ? entry.trainingIntro : entry?.trainingIntro?.html
    const introText = trainingIntroRaw?.includes('<p>') ? trainingIntroRaw : `<p>${trainingIntroRaw}</p>`
    intro = trainingIntroRaw ? `<h3>${t('PAGESUMMARY__PREPARATION')}</h3>${introText}` : false
  }

  const image = type === 'training' && entry?.trainingImage ? entry?.trainingImage[0] : false
  if (image && entry?.trainingImage[0].optimizedTrainingImage) {
    image.optimizedImageUrls = entry?.trainingImage[0].optimizedTrainingImage.optimizedImageUrls
    image.variantSourceWidths = entry?.trainingImage[0].optimizedTrainingImage.variantSourceWidths
  }

  if (type === 'program') {
    const programIntroRaw =
      typeof entry?.programIntro === 'string' ? entry.programIntro : entry?.programIntro?.html
    const introText = programIntroRaw?.includes('<p>') ? programIntroRaw : `<p>${programIntroRaw}</p>`
    intro = programIntroRaw ? `<h3>${t('PAGESUMMARY__DESCRIPTION')}</h3>${introText}` : false
  }

  detailContent = intro ? detailContent + intro : detailContent

  return (
    <div className={`PageSummary ${image ? 'PageSummary--hasFigure' : ''}`}>
      <div className="PageSummary-inner">
        <div className="PageSummary-content">
          {detailContent && (
            <div className="PageSummary-contentBlock">
              <div className="PageSummary-contentWrapper">
                <DetailBlock content={detailContent} />
                {reviews && reviews.length > 0 && (
                  <Button
                    label={`${t('PAGESUMMARY__PREVIOUS')} ${
                      reviews?.length > 1 ? t('PAGESUMMARY__EVALUATIONS') : t('PAGESUMMARY__EVALUATION')
                    }`}
                    inlineIcon={{ id: 'icon-chevron-right' }}
                    modal={{
                      type: 'api',
                      route: 'get/training-ratings',
                      id: entry.id
                    }}
                    modifiers={['Button--pageSummary']}
                  />
                )}

                {materialData?.[0] && image && (
                  <>
                    <DetailBlock content={`<h3>${t('PAGESUMMARY__REQUIREMENTS')}</h3>`} />
                    <MaterialBlock data={materialData} modifiers={['MaterialBlock--pageSummary']} />
                  </>
                )}
              </div>
            </div>
          )}

          {materialData?.[0] && !image && (
            <div className="PageSummary-contentBlock">
              <div className="PageSummary-contentWrapper">
                <DetailBlock content={`<h3>${t('PAGESUMMARY__REQUIREMENTS')}</h3>`} />
                <MaterialBlock data={materialData} modifiers={['MaterialBlock--pageSummary']} />
              </div>
            </div>
          )}

          {image && (
            <div className="PageSummary-figureBlock">
              <LazyImage image={image} alt={image.alt} modifiers={['LazyImage--pageSummary']} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

PageSummary.propTypes = {
  entry: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  materialData: PropTypes.array,
  reviews: PropTypes.array
}

export default PageSummary
